import { AxiosPostData } from "../context/axiosfunction"
import { message } from "antd"
import CryptoJS from "crypto-js"
import { getLocalStorage, setLocalStorage } from "@/lib/localStorage"
import { useGlobalContext } from "../context/provider"

export const useAddToCart = () => {
    const { API, headers, privateKey, Token, refreshCart } = useGlobalContext();
    const [messageApi, contextHolder] = message.useMessage();

    const addToCart = async (data) => {
        const existingEncrypted = getLocalStorage('Cart')?.value;

        let cart = [];

        // console.log(existingEncrypted);


        if (existingEncrypted) {
            try {
                const bytes = CryptoJS.AES.decrypt(existingEncrypted, privateKey);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                cart = JSON.parse(decrypted);
            } catch {
                cart = [];
            }
        }

        const isPreorder = data.type === 'preorder_campaign'

        // ตรวจสอบอ่านซีษ์: preorder ใช้ preorder_id, หนังสือปกติใช้ book_series_id
        const isDuplicate = isPreorder
            ? cart.some(cartdata => cartdata.preorder_id === data.preorder_id)
            : cart.some(cartdata => cartdata.book_series_id === data.book_series_id)

        if (isDuplicate) {
            return messageApi.open({
                type: 'warning',
                content: isPreorder ? 'มีพรีออเดอร์นี้อยู่ในตะกร้าแล้ว' : 'มีหนังสือเล่มนี้อยู่ในตะกร้าแล้ว'
            })
        }

        cart.unshift({
            book_series_id: isPreorder ? null : data.book_series_id,
            name: data.name,
            series_number: data.series_number,
            partner_id: data.partner_id,
            partner_name: data.partner,
            coin_price: data.coin_price,
            book_image: data.book_image,
            author: data.author,
            preorder_id: data.preorder_id ?? null,
            type: isPreorder ? 'preorder_campaign' : 'book_series'
        });

        if (Token) {
            if (isPreorder) {
                await AxiosPostData(API, '/api/add_cart', {
                    book_series_id: null,
                    preorder_campaign_id: data.preorder_id,
                    item_type: 'preorder_campaign'
                }, headers)
            } else {
                await AxiosPostData(API, '/api/add_cart', {
                    book_series_id: data.book_series_id,
                    preorder_campaign_id: null,
                    item_type: 'book_series'
                }, headers)
            }
        }

        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(cart), privateKey).toString();
        setLocalStorage('Cart', { value: encrypted });
        refreshCart();

        messageApi.open({
            type: 'success',
            content: 'เพิ่มหนังสือเข้าตะกร้าแล้ว'
        })
    }

    return { addToCart, contextHolder };
}